export const formatNumber = (num: number) => {
  let temp = num.toString().split(".")
  let [int, dec] = temp
  if (!int) return 0
  if (!dec) return `${Number(int).toLocaleString()}.00`
  return `${Number(int).toLocaleString()}.${(dec[0] || 0)}${(dec[1] || 0)}`
}

/** Thousands separators and exactly two (rounded) decimals, e.g. 9800.5 → '9,800.50'. */
export const formatFixed = (num: number): string =>
  num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
